import { render, staticRenderFns } from "./overseas-institutions.vue?vue&type=template&id=4e8258c1&"
import script from "./overseas-institutions.vue?vue&type=script&lang=js&"
export * from "./overseas-institutions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports